var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"testimonial-list"},[(_vm.loading)?_c('Loader',{attrs:{"loading":"true"}}):(_vm.testimonials)?_vm._l((_vm.testimonials),function(testimonial){return _c('TestimonialItem',{key:testimonial.Id,attrs:{"testimonial":testimonial}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }